import * as React from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import type { Tag } from 'modules/ats/hooks/tags/useTags'

import { NewTagForm } from './NewTagForm'
import { SearchEmptyState } from './SearchEmptyState'
import { TagItem } from './TagItem'

interface Props {
  tags: Tag[]
  open: boolean
  onClose: () => void
}

export const TagsSidepanel = ({ tags, open, onClose }: Props) => {
  const { search, onSearch, debouncedSearch } = useDebouncedSearch()

  const tagsToShow = search ? tags.filter((tag) => matchText(debouncedSearch, tag.name)) : tags

  return (
    <Sidepanel
      open={open}
      onClose={onClose}
      title={i18n.t('ats.tags.manager.title')}
      closeLabel={i18n.t('common.close')}
      width="wide"
    >
      <Box gap="s32">
        <NewTagForm />

        <Box gap="s16" background="grey200" padding="s32" borderRadius={{ all: 'abs008' }}>
          <SearchField
            variant="big"
            placeholder={i18n.t('ats.tags.search.placeholder')}
            search={search}
            onSearch={onSearch}
          />

          {tagsToShow.map((tag) => (
            <TagItem key={tag.name} tag={tag} />
          ))}

          {search && tagsToShow.length === 0 && <SearchEmptyState search={search} />}
        </Box>
      </Box>
    </Sidepanel>
  )
}
